import {
  UnlistedPriceDTO,
  Request,
} from "@campgladiator/cg-common.types.types";
import { fetchRequest } from "@campgladiator/cg-common.api.fetch-request";
import { getApiGatewayUrl } from "@campgladiator/cg-common.config.config";

export const fetchRecommitPrices = async (
  token?: string
): Promise<UnlistedPriceDTO[]> => {
  const endpoint = "/billing/v1/prices/recommits";
  const method = "GET";

  const request: Request = {
    requestConfig: {
      method,
      url: {
        baseUrl: getApiGatewayUrl(),
        endpoint,
      },
      authToken: token,
    },
  };

  const response = await fetchRequest({ request });

  const content = await response.json();

  return response.ok
    ? (content as UnlistedPriceDTO[])
    : Promise.reject(new Error(content?.error));
};

export const fetchOldPrices = async (): Promise<UnlistedPriceDTO[]> => {
  const endpoint = "/billing/v1/prices/olds";
  const method = "GET";

  const request: Request = {
    requestConfig: {
      method,
      url: {
        baseUrl: getApiGatewayUrl(),
        endpoint,
      },
    },
  };

  const response = await fetchRequest({ request });

  const content = await response.json();

  return response.ok
    ? (content as UnlistedPriceDTO[])
    : Promise.reject(new Error(content?.error));
};
